export default __webpack_public_path__ + "static/media/dy-patil.dce28532.png";